import { useT } from "../i18n/hooks.ts";
import type { FoundEhd } from "../model/project.ts";
import { Dialog } from "./Dialog.tsx";

/** Only shown when the chosen folder has more than one .ehd (counting subfolders) — openProject() can't guess which one the user wants. */
export function ChooseEhdDialog({
  found,
  onChoose,
  onClose,
}: {
  found: FoundEhd[];
  onChoose: (chosen: FoundEhd) => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={t("chooseEhdDialog.title")} onClose={onClose}>
      <p>{t("chooseEhdDialog.message")}</p>
      <ul className="editable-list">
        {found.map((e) => (
          <li key={e.path}>
            <button className="button-icon" onClick={() => onChoose(e)}>
              {e.path}
            </button>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
